import LogisticsManagementContainer from "../../components/logisticManagement/Layout";

const Index = () => {
    return <LogisticsManagementContainer />
}

export default Index;
